module.exports = __webpack_public_path__ + "static/img/ll3.18cb70d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/ll3.png
// module id = 7D3/
// module chunks = 1